import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import moment from "moment";

import {
  Loader,
  NumberInput,
  Button,
  Input,
  Toastr,
} from "@revvsales/components";
import { ReactSelect, DateSelect } from "../../commonComponents";

import NotesActions from "../../actions/NotesActions";
import PipelineActions from "../../actions/PipelineActions";
import { PIPELINE } from "../../constants";
import { GlobalUtils } from "../../utils";
import { prepareFormData } from "./methods";
import { USER_ROLES } from "../../constants/roleList";

// Destructuring
const { handleApiErrMsg, readDataFromLocalStorage } = GlobalUtils;
const { fetchAllUsersForMentions } = NotesActions;
const { createOpportunity, createAccount } = PipelineActions;
const { ADD_OPPO_FORM, ADD_ACCOUNT_FORM, OPPO_STAGES } = PIPELINE;

// Decalarations
const SALES_REP = USER_ROLES.USER;

class AddOpportunity extends Component {
  state = {
    oppoData: {},
    accountData: {},
    disableAdd: true,
    requiredFields: [],
    showAccountSelection: true,
    switchText: "Create an account",
    accSelectModeRequiredFields: [],
    accCreateModeRequiredFields: [],
    isSaving: false,
    showLoader: false,
  };

  componentDidMount() {
    if (this.props.mentionUsers.length === 0) {
      this._getMentionUsers();
    }
    this._updateFormRelatedData(this.props.mentionUsers);
  }

  _getMentionUsers = () => {
    this.setState({ showLoader: true });
    this.props
      .fetchAllUsersForMentions()
      .then(response => {
        this._updateFormRelatedData(response.users);
        this.setState({ showLoader: false });
      })
      .catch(error => {
        this.setState({ showLoader: false });
        console.error(`AddOpportunity => _getMentionUsers => ${error}`);
      });
  };

  _updateFormRelatedData = users => {
    const oppoData = {};
    const accountData = {};
    const requiredFields = [];
    const accCreateModeRequiredFields = [];
    ADD_OPPO_FORM.forEach(item => {
      if (item.name === "owner") {
        const findOwner = this._getCurrentUserFromMentionedUsersList(users);
        if (findOwner) {
          oppoData[item.name] = {
            id: findOwner.id,
            value: findOwner.name,
            label: findOwner.name,
          };
        } else {
          oppoData[item.name] = "";
        }
      } else {
        oppoData[item.name] = "";
      }

      if (item.required) {
        requiredFields.push(item.name);
      }
    });
    ADD_ACCOUNT_FORM.forEach(item => {
      accountData[item.name] = "";
      if (item.required) {
        accCreateModeRequiredFields.push(item.name);
      }
    });
    if (this.props.accountPreSelected && this.props.accounts.length > 0) {
      const preSelectedAccount = this.props.accounts.find(
        acc => acc.id === this.props.accountID,
      );
      if (preSelectedAccount) {
        oppoData.account = preSelectedAccount;
      }
    }
    this.setState({
      oppoData,
      accountData,
      requiredFields,
      accSelectModeRequiredFields: requiredFields,
      accCreateModeRequiredFields: [
        ...accCreateModeRequiredFields,
        ...requiredFields.filter(item => item !== "account"),
      ],
    });
  };

  _saveOpportunity = accountID => {
    const { oppoData, showAccountSelection } = this.state;
    const payload = {
      source: "RV",
      external_id: "",
      name: oppoData.opportunity,
      description: "",
      stage_name: oppoData.opportunityStage.value,
      close_date: oppoData.closeDate,
      amount: 0,
      expected_revenue: parseFloat(oppoData.expectedRevenue),
      is_closed: false,
      is_won: false,
      owner: {
        id: oppoData.owner.id,
        user_email: this.props.mentionUsers.find(
          user => user.name === oppoData.owner.value,
        ).user_email,
      },
      items: [],
    };
    if (!showAccountSelection) {
      payload.crm_account = {
        id: accountID,
      };
    } else {
      payload.crm_account = {
        id: oppoData.account.id,
      };
    }
    this.props
      .createOpportunity(payload, this.props.accountPreSelected)
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: "Your new opportunity has been created successfully.",
          timeout: 2000,
        });
        this.setState({ isSaving: false });
        this.props.toggleAddOppoPopup(false);
      })
      .catch(err => {
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(err),
          timeout: 3000,
        });
        this.setState({ isSaving: false });
        this.props.toggleAddOppoPopup(false);
      });
  };

  _save = () => {
    const { accountData, showAccountSelection } = this.state;
    let accountPayload = {};
    this.setState({ isSaving: true });
    // CREATE ACCOUNT CASE
    if (!showAccountSelection) {
      accountPayload = {
        source: "RV",
        external_id: "",
        name: accountData.accountName,
        type: "",
        phone: "",
        account_number: "",
        address: "",
        detailed_address: {
          street: accountData.accountAddressStreet,
          city: accountData.accountAddressCity,
          state: accountData.accountAddressState,
          postalcode: accountData.accountAddressZip,
          country: accountData.accountAddressCountry,
        },
        crm_custom_fields: {},
      };
      this.props
        .createAccount(accountPayload)
        .then(res => {
          this.setState({ isSaving: false });
          this._saveOpportunity(res.Account.id);
        })
        .catch(err => {
          Toastr.showToastr({
            type: "failure",
            message: handleApiErrMsg(err),
            timeout: 3000,
          });
          this.setState({ isSaving: false });
          this.props.toggleAddOppoPopup(false);
        });
      return "";
    }
    this._saveOpportunity();
    return "";
  };

  _getOptions = (name, selectOptionsKey) => {
    if (name === "opportunityStage") {
      return OPPO_STAGES;
    }
    return this.props[selectOptionsKey] || [];
  };

  _validateFields = () => {
    const { oppoData, accountData, requiredFields } = this.state;
    let disableAdd = false;
    for (let index = 0; index < requiredFields.length; index += 1) {
      if (
        (typeof oppoData[requiredFields[index]] === "string" &&
          oppoData[requiredFields[index]].trim() === "") ||
        (typeof accountData[requiredFields[index]] === "string" &&
          accountData[requiredFields[index]].trim() === "") ||
        oppoData[requiredFields[index]] === "" ||
        accountData[requiredFields[index]] === ""
      ) {
        disableAdd = true;
        break;
      }
    }
    this.setState({ disableAdd });
  };

  _onChange = (value, field) => {
    if (Object.prototype.hasOwnProperty.call(this.state.oppoData, field)) {
      this.setState(
        prevState => ({
          oppoData: { ...prevState.oppoData, [field]: value },
        }),
        () => this._validateFields(),
      );
    } else {
      this.setState(
        prevState => ({
          accountData: { ...prevState.accountData, [field]: value },
        }),
        () => this._validateFields(),
      );
    }
  };

  _changeAccountView = () => {
    this.setState(
      prevState => ({
        showAccountSelection: !prevState.showAccountSelection,
      }),
      () => {
        if (this.state.showAccountSelection) {
          // Select Account case
          this.setState({ switchText: "Create an account" });
          this.setState(
            prevState => ({
              requiredFields: [...prevState.accSelectModeRequiredFields],
            }),
            () => this._validateFields(),
          );
        } else {
          // Create Account case
          this.setState({ switchText: "Choose an existing account" });
          this.setState(
            prevState => ({
              requiredFields: [...prevState.accCreateModeRequiredFields],
            }),
            () => this._validateFields(),
          );
        }
      },
    );
  };

  _disableSelect = field => {
    if (field.name === "account" && this.props.accountPreSelected) {
      return true;
    }

    // In case of Owner selection, if the role of owner is "SalesRep" then,
    // disable the owner selection
    if (field.name === "owner") {
      const findOwner = this._getCurrentUserFromMentionedUsersList(
        this.props.mentionUsers,
      );
      if (findOwner) {
        const ownerRole = findOwner.roles[0];
        if (ownerRole && ownerRole.name === SALES_REP) {
          return true;
        }
      }
    }
    return false;
  };

  _getCurrentUserFromMentionedUsersList = users => {
    const currentUser = readDataFromLocalStorage("revvsalesUser");
    const findOwner = users.find(user => user.id === currentUser.id);
    if (findOwner) {
      return findOwner;
    }
    return null;
  };

  _renderForm = field => {
    const {
      type,
      name,
      span,
      label,
      required,
      selectOptionsKey,
      containsSwitchLink,
    } = field;
    let fieldBody;
    switch (type) {
      case "select":
        fieldBody = (
          <ReactSelect
            isSearchable
            options={this._getOptions(name, selectOptionsKey)}
            onChange={value => this._onChange(value, name)}
            value={this.state.oppoData[name]}
            valueKey="name"
            labelKey="name"
            isDisabled={this._disableSelect(field)}
            data-test="addopportunity-reactselect"
          />
        );
        break;
      case "text":
        fieldBody = (
          <Input
            placeholder={`Enter ${label}.`}
            value={this.state.oppoData[name]}
            onChange={e => this._onChange(e.target.value, name)}
            data-test="addopportunity-text-input"
          />
        );
        break;
      case "currency":
        fieldBody = (
          <NumberInput
            placeholder={`Enter ${label}.`}
            isCurrency={type === "currency"}
            isFloat
            value={this.state.oppoData[name]}
            onChange={val => this._onChange(val, name)}
            data-test="addopportunity-currency-input"
          />
        );
        break;
      case "date":
        fieldBody = (
          <DateSelect
            passDefaultDate
            selectedDate={
              this.state.oppoData[name]
                ? moment(this.state.oppoData[name])
                : null
            }
            returnValue={date =>
              this._onChange(moment(date).format("YYYY-MM-DD"), name)
            }
            placeholder="Click to pick a date."
            minDate={moment().format()}
          />
        );
        break;
      default:
        fieldBody = <p>No Field Available!</p>;
        break;
    }
    return (
      <div className={`addpbitem-div-wrapper item-${field.span}-span`}>
        <span className="addproduct-label">
          {label}
          <span className="required-input">{required ? "*" : ""}</span>
          {containsSwitchLink && !this.props.accountPreSelected ? (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              role="button"
              className="add-oppo-switch-text"
              tabIndex={0}
              onClick={() => this._changeAccountView()}
              onKeyDown={() => {}}
              data-test="addopportunity-account-view-link">
              {this.state.switchText}
            </a>
          ) : (
            ""
          )}
        </span>
        {fieldBody}
      </div>
    );
  };

  render() {
    return (
      <Modal
        open
        onClose={() => this.props.toggleAddOppoPopup(false)}
        closeOnOverlayClick={false}
        center>
        <div className="create-opportunity-wrapper">
          {this.state.showLoader && (
            <div className="addopportunity-loader-wrapper">
              <Loader />
            </div>
          )}
          <div className="row">
            <div className="pricingmethodwrapper-wrapper">
              <div className="pricingmethod-title">
                <span className="pricingmethodwrapper-header">
                  Add New Opportunity
                </span>
              </div>
            </div>
            {prepareFormData(this.state.showAccountSelection).map(field =>
              this._renderForm(field),
            )}
          </div>
          <section className="createquotepopup-footer popup-footer clearfix">
            <div className="footer-actions">
              <Button
                className="btn btn-transparent createquotepopup-footer-cancelbtn"
                onClick={() => this.props.toggleAddOppoPopup(false)}
                data-test="addopportunity-cancel-btn">
                Cancel
              </Button>
              <Button
                className="btn btn-primary"
                isLoading={this.state.isSaving}
                disabled={this.state.disableAdd}
                onClick={() => this._save()}
                data-test="addopportunity-create-btn">
                Create
              </Button>
            </div>
          </section>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { mentionUsers } = state.NotesStore;
  return {
    mentionUsers,
  };
};

const mapDispatchToProps = {
  fetchAllUsersForMentions,
  createOpportunity,
  createAccount,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddOpportunity);



// WEBPACK FOOTER //
// ./src/components/AddOpportunity/AddOpportunity.js